var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-empty',{attrs:{"hasHeader":_vm.hasHeader,"containerClass":"container-fluid"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"side"}),_c('div',{staticClass:"content p-grid"},[_vm._t("default")],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }